import { render, staticRenderFns } from "./asianWinterGamesFull_AWG.vue?vue&type=template&id=0b1d1bce"
import script from "./asianWinterGamesFull_AWG.vue?vue&type=script&lang=js"
export * from "./asianWinterGamesFull_AWG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports